(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Accessible payment-methods popover (drop-up on desktop, simple
  // expand/collapse on mobile via the same markup + a CSS breakpoint
  // that switches the popover from position:absolute to position:static).
  (function () {
    function init() {
      var toggle = document.querySelector('[data-mahsons-payment-toggle]');
      var popover = document.querySelector('[data-mahsons-payment-popover]');
      if (!toggle || !popover) return;

      function close() {
        popover.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      function open() {
        popover.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (popover.hidden) {
          open();
        } else {
          close();
        }
      });

      document.addEventListener('click', function (e) {
        if (!popover.hidden && !popover.contains(e.target) && e.target !== toggle) {
          close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popover.hidden) {
          close();
          toggle.focus();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Dawn's own native sticky-header mechanism, restored verbatim so the
  // <sticky-header> custom element above (used when sticky_header_type
  // != 'none') works exactly as it does in stock Dawn: it toggles
  // .shopify-section-header-sticky onto the auto-generated .section-header
  // wrapper (per the section's schema "class": "section-header") and sets
  // the --header-height custom property used elsewhere for offsetting
  // content below the sticky stack.
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Lightweight header basket total, matching the same ex-VAT convention used
  // throughout the Wholesale Catalogue. Refreshes on load and whenever the
  // catalogue dispatches its existing cart:updated event after Add to Basket.
  // EX-VAT ARCHITECTURE: cart.total_price is already the ex-VAT merchandise
  // total in pence, so it is only converted from pence to pounds. The old
  // /1.2 extraction was removed when the store moved off VAT-inclusive
  // pricing -- dividing again understated the basket by 20%.
  (function () {
    function formatBasketMoney(amount) {
      var n = parseFloat(amount);
      if (isNaN(n)) return '£0.00';
      return '£' + n.toFixed(2);
    }

    function updateHeaderBasketTotal() {
      var el = document.querySelector('[data-mahsons-basket-total]');
      if (!el) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var exVat = cart.total_price / 100;
          el.textContent = formatBasketMoney(exVat);
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateHeaderBasketTotal);
    } else {
      updateHeaderBasketTotal();
    }
    document.addEventListener('cart:updated', updateHeaderBasketTotal);
  })();

  // Header search: on the catalogue page (root "/"), forward typing straight
  // into the existing catalogue search input so results filter live using
  // the catalogue's own search/filter/sort pipeline -- no duplicate search
  // engine. On any other page, submitting the form just navigates to "/?q=…",
  // and the catalogue reads that "q" param on load (see wholesale-catalogue.js).
  (function () {
    function init() {
      var headerInput = document.querySelector('[data-mahsons-header-search-input]');
      var form = document.querySelector('[data-mahsons-header-search-form]');
      if (!headerInput || !form) return;

      var catalogueSearch = document.querySelector('[data-wc-search]');

      // Wholesale COLLECTION pages (sections/wholesale-collection-catalogue.liquid)
      // mark their catalogue wrapper with data-wc-search-scope="collection".
      // There the header search must stay a whole-catalogue search, so
      // keystrokes are NOT forwarded into that collection's own search box:
      // the form submits normally to "/?q=..." and the homepage catalogue
      // applies the query. The homepage catalogue has no such attribute, so
      // its behaviour is unchanged.
      if (catalogueSearch && catalogueSearch.closest('[data-wc-search-scope="collection"]')) {
        catalogueSearch = null;
      }

      var params = new URLSearchParams(window.location.search);
      var existingQuery = params.get('q');
      if (existingQuery) headerInput.value = existingQuery;

      if (catalogueSearch) {
        // Catalogue is present on this page: forward keystrokes directly,
        // and let the real search input's own listener do the filtering.
        headerInput.addEventListener('input', function () {
          catalogueSearch.value = headerInput.value;
          catalogueSearch.dispatchEvent(new Event('input', { bubbles: true }));
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
